import { ForgotPasswordForm } from '@/features/auth';

export default function ForgotPasswordPage() {
  return <ForgotPasswordForm />;
}
